import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import ReactPlayer from "react-player";
import { serverInfo } from "../App";
import "./GreetingsVideo.css";

const GreetingsVideo = () => {
  const { videoId } = useParams();
  const { videoCdnUrl } = useContext(serverInfo);
  const videoRef = useRef(null);

  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const videoUrl = `${videoCdnUrl}greetings/videos/${videoId}.mp4`;

  useEffect(() => {
    document.title = "Greetings Video | Hello Superstars";
    return () => {
      document.title = "Hello Superstars";
    };
  }, []);

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  if (hasError) {
    return (
      <div className="greetings-page">
        <div className="greetings-container">
          <div className="greetings-brand">
            <span className="greetings-logo-text">Hello Superstars</span>
          </div>
          <div className="greetings-error-card">
            <div className="greetings-error-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#e7da5d" strokeWidth="1.5" />
                <path d="M15 9l-6 6M9 9l6 6" stroke="#e7da5d" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </div>
            <h2 className="greetings-error-title">Video Unavailable</h2>
            <p className="greetings-error-text">
              This greeting video could not be found or may have expired.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="greetings-page">
      <div className="greetings-container">
        {/* Brand Header */}
        <div className="greetings-brand">
          <span className="greetings-logo-text">Hello Superstars</span>
          <span className="greetings-badge">Greetings</span>
        </div>

        {/* Video Card */}
        <div className="greetings-card">
          <div className="greetings-video-wrapper">
            {isLoading && (
              <div className="greetings-loader-overlay">
                <div className="greetings-spinner" />
                <p className="greetings-loader-text">Loading your greeting…</p>
              </div>
            )}

            <ReactPlayer
              ref={videoRef}
              className="greetings-video"
              url={videoUrl}
              playing={false}
              controls={true}
              width="100%"
              height="100%"
              onReady={() => setIsLoading(false)}
              onError={handleError}
              config={{
                file: {
                  attributes: {
                    controlsList: "nodownload",
                    playsInline: true,
                  },
                },
              }}
            />
          </div>


        </div>

        {/* Footer */}
        <div className="greetings-footer">
          <p>
            Powered by{" "}
            <a href="https://hellosuperstars.com/" target="_blank" rel="noopener noreferrer">
              <strong>Hello Superstars</strong>
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default GreetingsVideo;